<div class="group-block">
  <div class="group-block__header">
    <h2 class="fs__md">Group Questions</h2>
    <mat-slide-toggle
      [labelPosition]="'before'"
      [color]="'primary'"
      [formControl]="activeBlock().get('randomizedInd') | toFormControl"
      [checked]="activeBlock().value.randomizedInd"
    >
      Randomized
    </mat-slide-toggle>
  </div>

  <empathy-block-questions [activeBlock]="activeBlock()" [isSecondChild]="isSecondChild()" />
</div>
